import React, { Component } from "react";
import { swatches, fonts } from "./constants.js";
import { fabric } from "fabric";
import { Arrows } from "./Extras.jsx";
import { ChromePicker } from "react-color";
import { publish } from "./pubsubEngine";

export const Popover = props => {
  const handleClick = evt => {
    evt.stopPropagation();
  };
  return (
    <div onClick={handleClick} className={`popover ${props.position}`}>
      {React.Children.map(props.children, child => {
        return React.cloneElement(child, props);
      })}
    </div>
  );
};

export class ChooseColor extends Component {
  state = { selectedPart: "cup" };
  updatePart = selectedPart => {
    this.setState({
      selectedPart
    });
  };
  render() {
    const { selectColor } = this.props;
    const { selectedPart } = this.state;
    return (
      <div>
        <section className="popover-heading row">CHOOSE COLOR</section>
        <section className="tabs">
          <div
            className={`tab ${selectedPart === "cup" ? "selected" : ""}`}
            onClick={() => this.updatePart("cup")}
          >
            Cup
          </div>
          <div
            className={`tab ${selectedPart === "lid" ? "selected" : ""}`}
            onClick={() => this.updatePart("lid")}
          >
            Lid
          </div>
          <div
            className={`tab ${selectedPart === "cap" ? "selected" : ""}`}
            onClick={() => this.updatePart("cap")}
          >
            Cap
          </div>
          <div
            className={`tab ${selectedPart === "overmold" ? "selected" : ""}`}
            onClick={() => this.updatePart("overmold")}
          >
            Overmold
          </div>
        </section>
        <section className="row swatches">
          {swatches.map((swatch, index) => {
            return (
              <div
                key={`${swatch.color}-${index}`}
                onClick={() => selectColor(selectedPart, swatch.name)}
                className={`swatch ${swatch.bordered &&
                  "bordered"} ${swatch.black && "black"}`}
                style={{ backgroundColor: swatch.color }}
              />
            );
          })}
        </section>
      </div>
    );
  }
}

export class ChooseLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: null
    };
  }
  _updateLogo(e) {
    this.setState({
      logo: e.target.files,
      // Warn for files over 2MB in size.
      sizeWarning: e.target.files[0].size / 1024 / 1024 > 2
    });
  }
  _uploadLogo() {
    let self = this;
    const reader = new FileReader();
    reader.onload = function(event) {
      const result = event.target.result;
      if (self.state.logo[0].type === "image/svg+xml") {
        fabric.loadSVGFromString(result, (objects, options) => {
          publish(fabric.util.groupSVGElements(objects, options));
        });
      } else {
        let imgElement = document.createElement("img");
        imgElement.onload = () => {
          //const ratio = imgElement.height / imgElement.width;
          const resizeWidth = 140;
          const scale = resizeWidth / imgElement.width;
          const img = new fabric.Image(imgElement, {
            left: 105,
            top: 420,
            scale
          });
          img.set({ scaleX: scale, scaleY: scale });
          publish(img);
        };
        imgElement.src = result;
      }
    };
    if (!this.state.logo) return;
    if (this.state.logo[0].type === "image/svg+xml") {
      reader.readAsText(this.state.logo[0]);
    } else {
      reader.readAsDataURL(this.state.logo[0]);
    }
    this.props.togglePopover();
  }
  render() {
    let logoState;
    if (!this.state.logo) {
      logoState = "Choose an image file";
    } else {
      logoState = this.state.logo[0].name;
    }
    return (
      <div>
        <section className="popover-heading row">UPLOAD LOGO</section>
        <section className="row">
          <p className="logo-explanation">
            Upload 300 dpi images for best printing result. Please select images
            in JPG, PNG, GIF or SVG formats only.
          </p>
        </section>
        <section className="row">
          <label className="file">
            <input
              type="file"
              id="file"
              onChange={this._updateLogo.bind(this)}
            />
            <span className="file-custom" data-state={logoState} />
          </label>
        </section>
        {this.state.sizeWarning && <section className="row">
          <p className="logo-explanation text-danger">Files over 2MB might cause unexpected results.</p>
        </section>}
        <section className="row">
          <div className="button-container">
            <button
              onClick={this._uploadLogo.bind(this)}
              className="button-focus"
            >
              UPLOAD LOGO <Arrows />
            </button>
            <button
              onClick={this.props.togglePopover}
              className="button-focus cancel-button  visible-xs-block visible-sm-block"
            >
              CANCEL <Arrows />
            </button>
          </div>
        </section>
      </div>
    );
  }
}
export class ChooseText extends React.Component {
  constructor(props) {
    super(props);
    if (props.text) {
      if (props.text.props) {
        this.state = {
          color: props.text.props.fill,
          font: props.text.props.fontFamily,
          text: props.text.props.text,
          colorShown: false,
          fontsShown: false
        };
      }
    } else {
      this.state = {
        color: "#000",
        font: "Arial",
        text: "",
        colorShown: false,
        fontsShown: false
      };
    }
  }
  pickFont(font) {
    this.setState({
      font: font
    });
  }
  _handleColor({ hex }) {
    this.setState({
      color: hex
    });
  }
  _toggleColorPicker() {
    this.setState({
      colorShown: !this.state.colorShown,
      fontsShown: false
    });
  }
  _toggleFontPicker() {
    this.setState({
      fontsShown: !this.state.fontsShown,
      colorShown: false
    });
  }
  _addText() {
    const color = this.state.color;
    const font = this.state.font;
    const text = new fabric.Text(this.refs.textarea.value, {
      left: 105,
      top: 420,
      fill: color,
      fontFamily: font
    });
    publish(text);
    this.props.togglePopover();
  }
  render() {
    return (
      <div>
        <section className="popover-heading row">ADD TEXT</section>
        <section className="row text-area">
          <textarea
            ref="textarea"
            rows={2}
            style={{ color: this.state.color, fontFamily: this.state.font }}
            defaultValue={this.state.text}
          />
        </section>
        <section className="row button-area">
          <div className="col-sm-4">
            <button onClick={this._toggleFontPicker.bind(this)}>
              CHOOSE FONT <Arrows focus />
            </button>
            <div
              className={`font-holder ${!this.state.fontsShown &&
                "transparent"}`}
            >
              <div className="font-title">Fonts</div>
              <div className="font-list">
                {fonts.map(font => {
                  return (
                    <p
                      key={font.id}
                      className={`font-listing ${
                        this.state.font === font.id ? "selected" : ""
                      }`}
                      onClick={this.pickFont.bind(this, font.id)}
                      style={{ fontFamily: font.id, cursor: "pointer" }}
                    >
                      {font.name}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <button onClick={this._toggleColorPicker.bind(this)}>
              CHOOSE COLOR <Arrows focus />
            </button>
            <div
              className={`color-holder ${!this.state.colorShown &&
                "transparent"}`}
            >
              <ChromePicker
                color={this.state.color}
                onChangeComplete={this._handleColor.bind(this)}
              />
            </div>
          </div>
          <div className="col-sm-4">
            <button className="button-focus" onClick={this._addText.bind(this)}>
              CONTINUE <Arrows />
            </button>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Popover.jsx